import { t as translate, J as JS_PREFIX, f as CSS_PREFIX, g as CSS_UTILITY_PREFIX, D as DECATHLON_NAMESPACE } from './built-constants-439d5572.js';

/**
 * Icon prefix
 */
const ICON_PREFIX = CSS_PREFIX + "Icon-";
/**
 * SUFFIXES
 */

/**
 * Container (e.g., for Handlebars)
 */

const CONTAINER_SUFFIX = '-container';
/**
 * Template (e.g., for Handlebars)
 */

const TEMPLATE_SUFFIX = '-template';
/**
 * CSS Classes
 */

/**
 * The CSS classes used to update the UI on variant changes
 */

const IS_ACTIVE_CLASS = CSS_PREFIX + "is-active";
const IS_TRANSITIONING_CLASS = CSS_PREFIX + "is-transitioning";
const IS_OUT_OF_STOCK_CLASS = CSS_PREFIX + "is-outofstock";
const IS_SOLD_OUT_CLASS = CSS_PREFIX + "is-soldout";
const VALIDATION_MESSAGE_CLASS = JS_PREFIX + "validation-message";
/**
 * TEXT CONSTANTS
 */

/**
 * Text used to update UI elements
 * V.31032021
 */

const PRODUCT_PAGE_COPY = {
  SELECT_A_SIZE: translate("Selecciona una variante"),
  ADD_TO_CART: translate("Agregar al carrito"),
  SOLD_OUT: translate(""),
  EMAIL_ME_WHEN_IN_STOCK: translate("Enviame un correo cuando este disponible"),
  OUT_OF_STOCK: translate(""),
  ALL_SIZES_OUT_OF_STOCK: translate("Todos los tamaños están agotados"),
  NEW_MODEL_IN_DESIGN: translate("Nuevo diseño"),
  OUT_OF_STOCK_RECENTLY_CHANGED: translate("Agotado, el inventario acaba de cambiar"),
  INVENTORY_RECENTLY_CHANGED: translate("El inventario acaba de cambiar"),
  ALL_AVAILABLE_PRODUCTS_IN_CART: translate("Todos los productos disponibles estan en tu carrito"),

  /**
   * @param {string | number} quantity
   * @returns {string}
   */
  allInStockProductsInYourCart: quantity => "All in stock products are now in your cart. " + quantity + " " + (Number(quantity) === 1 ? 'was' : 'were') + " added.",

  /**
   * Provides the proper UI text to display
   * • If quantity 0 left => "0 left"
   * • If quantity > 0 => "Only X left"
   * @todo Consider moving out of constants because different values can be returned
   * @param {string | number} quantity
   * @returns {string}
   */
  limitedQuantityLeft: quantity => quantity === 0 ? "" + (quantity && translate("Izquierda")) : quantity === "1" ? "" + translate("", {
    quantity
  }) : "" + translate("", {
    quantity
  })
};
/*
 * CSS class that sets content to a fixed (no scroll) state
 */

const FIXED_CLASS = CSS_PREFIX + "content-is-fixed";
/*
 * CSS class that indicates an element should hide vertical overflow
 */

const HIDE_OVERFLOW_Y_CLASS = CSS_UTILITY_PREFIX + "overflowYNone";
/**
 * CSS class used by components that need an "open" state
 */

const IS_OPEN = CSS_PREFIX + "is-open";

// @ts-check
let defaultMoneyFormat = null;
const DEFAULT_PRECISION = 2;
const DEFAULT_THOUSANDS_SEPARATOR = ',';
const DEFAULT_DECIMAL = '.';
/**
 * Gets value off the Decathlon Globals namespace on `window`
 * Getter seems to be needed for tests to pass after setting the value on the \
 * namespace
 * @returns {string} The default money format or an empty string if the value
 * cannot be found. In this case, the switch/case in `formatMoney` will return
 * the generic default format that results from using `${{amount}}`
 */

const getDefaultMoneyFormat = () => {
  if (!defaultMoneyFormat) {
    var _window$DECATHLON_NAM;

    // Returns
    defaultMoneyFormat = ((_window$DECATHLON_NAM = window[DECATHLON_NAMESPACE]) == null ? void 0 : _window$DECATHLON_NAM.moneyFormat) || '';
    console.log(defaultMoneyFormat);
  }

  return defaultMoneyFormat;
};
/**
 * Helper filter for valid price values
 * @param {string} price
 * @returns {boolean}
 */


const validPrice = price => price !== '' && price !== 'none';
/**
 * Converts a set of prices into an array by `delimiter`
 *
 * @param {string} prices e.g. '1000==499==5000'
 * @param {string} delimiter The delimiter to split on
 * @returns {string[]} An array of strings representing prices
 */


const getValidPriceList = (prices, delimiter) => {
  if (!prices) return [];
  return prices.split(delimiter).filter(validPrice);
};
/**
 * The formatting helper that takes in formatting parameters and gets defaults
 * as needed
 *
 * @param {string | number} number - The amount to be formatted
 * @param {number} [precision=DEFAULT_PRECISION] - What decimal precision to use
 * @param {string} [thousands=DEFAULT_THOUSANDS_SEPARATOR] - A thousands separator
 * @param {string} [decimal=DEFAULT_DECIMAL] - The symbol for a decimal
 * @returns {string}
 */

const formatWithDelimiters = (number, precision = DEFAULT_PRECISION, thousands = DEFAULT_THOUSANDS_SEPARATOR, decimal = DEFAULT_DECIMAL) => {
  if (isNaN(Number(number)) || number === null) {
    return '0';
  }

  const _number = (Number(number) / 100.0).toFixed(precision);

  const parts = _number.split('.');
  /**
   *
   * @param {string} match - The matched substring
   * @param {string} p1 - The first captured group
   */


  const dollarsReplacer = (match, p1) => "" + p1 + thousands;

  const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, dollarsReplacer);
  const cents = parts[1] ? decimal + parts[1] : '';
  return dollars + cents;
};
/**
 * The base function that takes in cents and a string representing a desired
 * format to be returned (e.g., US dollars and cents) and returns the formatted
 * string
 *
 * @param {string} cents
 * @TODO - Add default format string from `liquid`
 * @param {string} format - The formatting string to use
 * @returns {string}
 */


const formatMoney = (cents, format) => {
  let _cents = '';

  if (typeof cents === 'string') {
    _cents = cents.replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const matches = format.match(placeholderRegex);

  switch (matches[1]) {
    case 'amount':
      value = formatWithDelimiters(_cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(_cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(_cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(_cents, 0, '.', ',');
      break;

    default:
      value = formatWithDelimiters(_cents, 2);
      break;
  }

  const hideDecimals = document.getElementById("hideDecimals");

  if (hideDecimals) {
    value = value.replace(hideDecimals.innerHTML, '');
  }

  return format.replace(placeholderRegex, value);
};
/**
 * Formats a price range for UI display
 *
 * e.g. '$4.99 — $19.99'
 *
 * @param {string} prices - A delimited set of prices, e.g. '3.99|4.99'
 * @param {string} [delimiter='=='] - The prices list delimiter to split on
 * @param {string} [moneyFormat=defaultMoneyFormat] - A string representing the current Shopify store's
 * money format
 * @returns {string}
 */


const formatPriceRange = (prices, delimiter = '==', moneyFormat = getDefaultMoneyFormat()) => {
  if (!prices) return ''; // Turn `priceList` into an array of numbers to pass to `Math.min` and `Math.max`

  const priceList = getValidPriceList(prices, delimiter).map(priceString => Number(priceString));
  const minPrice = Math.min(...priceList).toString();
  const maxPrice = Math.max(...priceList).toString(); // Handle case where the min and max are the same

  if (minPrice === maxPrice) {
    return formatPriceSingle(minPrice, moneyFormat);
  }

  return formatPriceSingle(minPrice, moneyFormat) + " \u2014 " + formatPriceSingle(maxPrice, moneyFormat);
};
/**
 * Formats a single price for UI display
 *
 * e.g. '$10.00'
 *
 * @param {string | number} price - A single price, e.g. '1000'
 * @param {string} moneyFormat - A string representing the current Shopify store's
 * money format
 * @returns {string}
 */

const formatPriceSingle = (price, moneyFormat = getDefaultMoneyFormat()) => {
  // We need to allow an empty string to be displayed as a price
  if (price === null || price === undefined || price.toString().trim() === '') return ''; // Otherwise format the price, including a falsy value of `0` => `"$0.00"`

  return formatMoney(price.toString(), moneyFormat);
};
/**
 * Formats a single price for UI display (QATAR)
 *
 * e.g. '$10.00'
 *
 * @param {string | number} price - A single price, e.g. '1000'
 * @param {string} moneyFormat - A string representing the current Shopify store's
 * money format
 * @returns {string}
 */

const formatPriceSecondary = (price, moneyFormat = sessionStorage.getItem('secondaryCurrency') + ' {{amount_with_comma_separator}}') => {
  // We need to allow an empty string to be displayed as a price
  if (price === null || price === undefined || price.toString().trim() === '') return ''; // Otherwise format the price, including a falsy value of `0` => `"$0.00"`

  return formatMoney(price.toString(), moneyFormat);
};

export { CONTAINER_SUFFIX as C, FIXED_CLASS as F, HIDE_OVERFLOW_Y_CLASS as H, IS_ACTIVE_CLASS as I, PRODUCT_PAGE_COPY as P, TEMPLATE_SUFFIX as T, VALIDATION_MESSAGE_CLASS as V, formatPriceSecondary as a, formatPriceRange as b, IS_OPEN as c, ICON_PREFIX as d, IS_TRANSITIONING_CLASS as e, formatPriceSingle as f, getValidPriceList as g, IS_OUT_OF_STOCK_CLASS as h, IS_SOLD_OUT_CLASS as i };
